
// login / fetchme helpers

// src/auth/auth.ts
import axios from "axios";
import api, { setAccessToken } from "../api/client";

export type User = {
  id: number;
  username: string;
  is_superuser: boolean;
  email: string;
  google_maps_api_key?: string | null;
};

export const login = async (username: string, password: string) => {
  const res = await api.post("/auth/login/", { username, password });
  const access = res.data.access;
  setAccessToken(access);
  return res.data;
};

export const fetchMe = async (): Promise<User> => {
  const res = await api.get("/me/");
  return res.data;
};

// TODO: Should exception handling be in other auth code?
export const logoutApi = async () => {
    try {
  await api.post("/auth/logout/", {});
    }
    finally {
    setAccessToken(null);
    }
};

// export const refreshToken = async () => {
//     try {
//   const res = await api.post("/auth/refresh/");
//   const access = res.data.access;
//   setAccessToken(access);
//     }
//     catch {
//         setAccessToken(null); // or are we now swallowing when we shouldn't?
//     }
// }

export const refreshToken = async () => {
  // Use axios, NOT api (which triggers interceptors)
  return axios.post(
    // "http://127.0.0.1:8000/api/auth/refresh/",
    import.meta.env.VITE_API_BASE_URL + "/auth/refresh/",
    {},
    { withCredentials: true }
  ).then((r) => {
    setAccessToken(r.data.access);
    return r.data;
  });
};



// import axios from "axios";

// const api = axios.create({
// //   baseURL: "https://www.pure.tmadvances.com/api",
//   baseURL: "http://127.0.0.1:8000/api",
//   withCredentials: true, // if you store refresh in httpOnly cookie
// });

// // Store access token in memory (safer than localStorage)
// let accessToken: string | null = null;

// export const setAccessToken = (token: string | null) => {
//   accessToken = token;
// };

// api.interceptors.request.use((config) => {
//   if (accessToken) {
//     config.headers.Authorization = `Bearer ${accessToken}`;
//   }
//   return config;
// },
//   (err) => Promise.reject(err)
// );

// // Auto-refresh on 401
// api.interceptors.response.use(
//   (res) => res,
//   async (error) => {
//     const original = error.config;
//     if (error.response?.status === 401 && !original._retry) {
//       original._retry = true;
//       try {
//         const res = await axios.post(
//           "http://127.0.0.1:8000/api/token/refresh/",
//           {},
//           { withCredentials: true }
//         );
//         const newToken = res.data.access;
//         setAccessToken(newToken);
//         original.headers.Authorization = `Bearer ${newToken}`;
//         return api(original);
//       } catch (err) {
//         setAccessToken(null);
//       }
//     }
//     return Promise.reject(error);
//   }
// );

// export default api;

// // ---- AUTH CALLS ----

// export const login = async (username: string, password: string) => {
//   const res = await api.post("/token/", { username, password });
//   setAccessToken(res.data.access);
//   return res.data;
// };

// export const fetchMe = async () => {
//   const res = await api.get("/me/");
//   return res.data;
// };
